<template>
  <div class="data-table" :style="`height:${dispH}px`">
    <div ref="scroller" class="data-wrapper">
      <div class="padding">
        <div class="pulldown-wrapper">
          <div v-if="isBeforePullDown">
            <span
              class="iconfont icon-gengduo"
              style="font-size: 50px; color: rgba(255, 255, 255, 0.8)"
            ></span>
          </div>
          <!-- <div v-if="!isBeforePullDown">
            <div v-if="isPullingDown">
              <span class="el-icon-loading"></span>
              <span>Loading...</span>
            </div>
          </div> -->
        </div>
        <el-table
          ref="table"
          :data="tableData"
          :row-style="rowCtyle"
          :header-row-style="headerStyle"
          highlight-current-row
          @current-change="crruentRowChanged"
          @row-click="rowClick"
          @cell-click="cellClick"
          :lazy="true"
        >
          <!-- <span style="color: rgba(255, 255, 255, 0.2)" slot="empty">{{
            $t("langcfg.txtNoData")
          }}</span> -->
          <el-table-column
            header-align="center"
            align="center"
            v-for="(item, index) in headers"
            :key="index"
            :prop="item.prop"
            :label="$t(`langcfg.${item.label}`)"
            :width="item.width"
          >
          </el-table-column>
          <el-table-column
            v-if="!needSelectFirstRow"
            header-align="center"
            align="center"
            :label="$t('langcfg.txtOperation')"
          >
            <template slot-scope="scope">
              <el-button
                style="width: 120px; font-size: 34px"
                @click.native.prevent.stop="handleDelete(scope.$index, scope.row)"
                >✘</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="pullup-wrapper" v-show="isPullUpLoadNeeded">
          <div v-if="!isPullingUpLoad" class="before-trigger">
            <span class="pullup-txt">Pull up and load more</span>
          </div>
          <div v-else class="after-trigger">
            <span class="el-icon-loading"></span>
            <span class="pullup-txt">Loading...</span>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="back-top-container" v-if="showbacktop" @click="back2top">
      <span class="iconfont icon-backtop btn-oprator"></span>
    </div> -->
  </div>
</template>

<script>
// import BScroll from 'better-scroll'
import { Size } from "../../../mixins";
export default {
  data() {
    return {
      isPullingUpLoad: false,
      isPullUpLoadNeeded: false,
      isBeforePullDown: true,
      isPullingDown: false,
      showbacktop: false
      // bscroll: undefined
    };
  },
  mixins: [Size],
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    headers: {
      type: Array,
      default: () => {
        return [];
      }
    },
    currentIndex: {
      type: Number,
      default: -1
    },
    needSelectFirstRow: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.bscroll = null;
  },
  mounted() {
    // this.isPullUpLoadNeeded = this.tableData.length >= 50
    // this.$nextTick(() => {
    //   this.initBscroll()
    //   this.mounted = true
    // })
  },
  watch: {
    currentIndex() {
      this.setCurrRow();
    },
    tableData() {
      this.setCurrRow();
    }
  },
  methods: {
    setCurrRow() {
      if (this.currentIndex >= 0) {
        this.$refs.table.setCurrentRow(this.tableData[this.currentIndex]);
      } else {
        this.$refs.table.setCurrentRow(this.tableData[0]);
      }
    },
    touchend() {},
    // back2top () {
    //   this.$emit('back-top')
    //   this.bscroll.scrollTo(0, 0, 1000)
    // },
    cellClick(row, col) {
      if (col.property === "operation") {
        this.$emit("cell-click", row);
      }
    },
    handleDelete(index, row) {
      this.$emit("cell-click", row);
    },
    rowClick(row, col) {
      if (col.property !== "operation") {
        this.$emit("row-click", row);
      }
    },
    headerStyle() {
      return {
        fontSize: "25px",
        background: "transparent",
        height: "50px"
      };
    },
    rowCtyle() {
      return {
        fontSize: "28px",
        background: "transparent",
        height: "60px"
      };
    },
    crruentRowChanged(row) {
      this.$emit("current-row-changed", row);
    },
    refresh(updown) {
      setTimeout(() => {
        this.isPullingDown = false;
        if (updown === "up") {
          this.bscroll.finishPullUp();
        } else {
          this.bscroll.finishPullDown();
        }
        this.bscroll.refresh();
        this.isBeforePullDown = true;
      }, 1000);
    }
    // initBscroll () {
    //   this.bscroll = new BScroll(this.$refs.scroller, {
    //     scrollY: true,
    //     probeType: 2,
    //     pullUpLoad: true,
    //     mouseWheel: true,
    //     pullDownRefresh: true,
    //     disableMouse: false,
    //     disableTouch: false,
    //     click: true
    //   })
    //   this.bscroll.on('scroll', () => {
    //     console.log(this.bscroll.y)
    //     this.showbacktop = this.bscroll.y < 0
    //   })
    //   this.bscroll.on('pullingUp', () => {
    //     this.isPullingUpLoad = true
    //     this.$emit('pulling-up', () => {
    //       this.refresh('up')
    //     })
    //   })
    //   this.bscroll.on('pullingDown', () => {
    //     this.isBeforePullDown = false
    //     this.isPullingDown = true
    //     this.$emit('pulling-down', () => {
    //       this.refresh('down')
    //     })
    //   })
    // }
  }
};
</script>

<style lang="less" scoped>
.data-table {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.data-table-header {
  width: 100%;
  background-color: @page-background;
}
.padding {
  padding-left: @content-to-left;
  padding-right: @content-to-left;
}
.pullup-list {
  padding: 0;
}

.pullup-list-item {
  padding: 10px 0;
  list-style: none;
  height: 50px;
}
.pullup-wrapper {
  padding: 20px;
  text-align: center;
  color: #999;
}
.pulldown-wrapper {
  position: absolute;
  padding: 20px;
  width: 99%;
  box-sizing: border-box;
  transform: translateY(-100%) translateZ(0);
  text-align: center;
  color: #999;
}
td {
  vertical-align: middle;
}
.data-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.back-top-container {
  position: absolute;
  width: 70px;
  height: 70px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 35px;
  bottom: 30px;
  right: 1%;
  display: flex;
  align-items: center;
  .btn-oprator {
    font-size: 40px;
    color: white;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/basic/DataTable.vue